import type { EChartsOption } from '../echarts-types.ts';
import type { ChartConfig } from '../types.ts';
import { chartTheme } from '../theme.ts';
import { optionContext } from './shared.ts';
import {
  buildBarOption,
  buildColumnOption,
  buildGroupedColumnOption,
  buildStackedBarOption,
} from './bar.ts';
import { buildPieOption, buildFunnelOption } from './pie.ts';
import { buildLineOption, buildAreaOption } from './line.ts';
import { buildScatterOption } from './scatter.ts';
import { buildRadarOption } from './radar.ts';
import { buildGaugeOption } from './gauge.ts';
import { buildHeatmapOption } from './heatmap.ts';
import { buildWorldMapOption } from './world-map.ts';
import { buildSunburstOption } from './sunburst.ts';
import { buildBubblesOption } from './bubbles.ts';
import { buildDivergingBarOption } from './diverging-bar.ts';

export function buildOption(config: ChartConfig): EChartsOption {
  const ctx = optionContext(chartTheme());

  switch (config.type) {
    case 'bar':
      return buildBarOption(config, ctx);
    case 'column':
      return buildColumnOption(config, ctx);
    case 'grouped_column':
      return buildGroupedColumnOption(config, ctx);
    case 'stacked_bar':
      return buildStackedBarOption(config, ctx);
    case 'pie':
      return buildPieOption(config, ctx);
    case 'bubbles':
      return buildBubblesOption(config, ctx);
    case 'diverging_bar':
      return buildDivergingBarOption(config, ctx);
    case 'sunburst':
      return buildSunburstOption(config, ctx);
    case 'funnel':
      return buildFunnelOption(config, ctx);
    case 'line':
      return buildLineOption(config, ctx);
    case 'area':
      return buildAreaOption(config, ctx);
    case 'scatter':
      return buildScatterOption(config, ctx);
    case 'gauge':
      return buildGaugeOption(config, ctx);
    case 'heatmap':
      return buildHeatmapOption(config, ctx);
    case 'world_map':
      return buildWorldMapOption(config, ctx);
    case 'radar':
      return buildRadarOption(config, ctx);
    default:
      return {};
  }
}
